import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

type Options = {
  includeTime?: boolean
}

// Will Format date to the given options
export const formatDate = (
  date: string | Date,
  { includeTime = false }: Options = {},
) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    // will used in future if needed
    // timeZone: 'UTC', // default timezone: system
  }

  if (includeTime) {
    options.hour = 'numeric'
    options.minute = 'numeric'
    options.second = 'numeric'
  }

  return new Date(date).toLocaleDateString('en-GB', options)
}

/**
 * Will Remove the time from the UTC date string and return date in yyyy-mm-dd
 */
export const getOnlyDate = (date?: Date) => {
  if (!date) {
    return ''
  }
  return dayjs(date).format('YYYY-MM-DD')
}

export const formatOrderDate = (date: Date | string) => {
  return dayjs.utc(date).format('DD/MM/YY hh:mm A')
}

export const convertTo12HourFormat = (date: Date | string) => {
  return dayjs(date).format('DD/MM/YY hh:mm A')
}
